<template>
  <NewStudioModalsModalShell class="login-modal" title="My Studio Login" size="compact" data-figma-node="2909:175938" @close="$emit('close')">
    <p id="new-login-description" class="login-intro">Simply enter an email address to save all your designs in one place!</p>
    <form @submit.prevent="login">
      <label class="sr-only" for="new-login-email">Email Address</label>
      <input id="new-login-email" v-model.trim="email" type="email" placeholder="Enter your email" required autocomplete="email">
      <p v-if="error" role="alert">{{ error }}</p>
      <button type="submit" aria-describedby="new-login-description" :disabled="working || !email">{{ working ? 'Logging in…' : 'Login' }}</button>
      <button v-if="options?.continueWithoutSaving" class="continue" type="button" :disabled="working" @click="continueWithoutLogin">Continue Without Saving</button>
    </form>
  </NewStudioModalsModalShell>
</template>

<script setup lang="ts">
import { ModalType } from '~/stores/modal'
import { completeNewStudioModal, continueWithoutSaving } from '../logic'
defineEmits<{ close: [] }>()
const userStore = useUserStore()
const modalStore = useModalStore()
const email = ref('')
const error = ref('')
const working = ref(false)
const options = computed(() => modalStore.getModalOptions(ModalType.Login))
const login = async () => {
  error.value = ''
  working.value = true
  try {
    const success = await userStore.login(email.value)
    if (!success) { error.value = 'We could not log you in. Check your email and try again.'; return }
    await completeNewStudioModal(modalStore, ModalType.Login)
  } catch { error.value = 'We could not log you in. Please try again.' }
  finally { working.value = false }
}
const continueWithoutLogin = async () => {
  error.value = ''
  working.value = true
  try { await continueWithoutSaving(modalStore, ModalType.Login) }
  catch { error.value = 'We could not continue to the cart. Please try again.' }
  finally { working.value = false }
}
</script>

<style scoped>
.login-intro { margin: 17.95px 0 0; color: #55554f; font-size: 16px; font-weight: 600; } form { display: grid; gap: 17.95px; margin-top: 17.95px; }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0,0,0,0); }
input { box-sizing: border-box; height: 50px; padding: 0 18px; border: 2px solid #d9d8d3; font: inherit; font-size: 17.95px; font-weight: 600; }
p[role='alert'] { margin: 0; color: #a32121; font-size: 13px; }
button { min-height: 52px; border: 0; background: #2e3a46; color: #fff; font: inherit; font-size: 16.155px; font-weight: 700; cursor: pointer; }
button.continue { border-color: #deddd9; color: #777671; }
button:disabled { cursor: not-allowed; }
:global(.login-modal > h2) { margin-top: 17.95px; text-align: left; font-size: 34.105px; letter-spacing: -.341px; }
:global(.login-modal) { box-sizing: border-box; min-height: 334px; }
</style>
